export default __webpack_public_path__ + "static/media/Error.3e61750f.png";